export default __webpack_public_path__ + "static/media/1_Prestigio_Impero.f2a4ff84.jpg";